module.exports = __webpack_public_path__ + "static/media/myBookingsGreen.5724fc51.svg";